import "./footer.css"


export default function Footer() {
    return (
  
      <div className="footer-container">
          <div className="footer-content">
              <div className="row" id="links"> 
                    <a href="https://www.linkedin.com/in/jamiegarcia123456789/" target="_blank">LinkedIn</a>
                    <a href="https://github.com/JamieGarcia123" target="_blank">GitHub</a>
              </div>
          </div>
      </div>
    )} 